import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { PartsManagementSearchTextForm } from '../../../form-model/parts-management-search-text.form.model';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-search',
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './parts-management-search.component.html',
  styleUrl: './parts-management-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchComponent {
  @Input({ required: true }) partsManagementSearchTextForm!: FormGroup<PartsManagementSearchTextForm>;

  applySearchTextFilters() {
    this.partsManagementSearchTextForm.controls.appliedPMSearchTextFilter.setValue(true);
  }
  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.addControlsToTheFormGroup();
  }

  isControlInErrorState(control: FormControl): boolean | null {
    if (control.invalid && control.touched) {
      return true;
    }
    return null;
  }

  private addControlsToTheFormGroup() {
    const validTextSearchPattern = /^[A-Za-z0-9\-\/]+$/;
    this.partsManagementSearchTextForm.addControl(
      'searchText',
      this.formBuilder.control<string | null>(null, {
        validators: [Validators.pattern(validTextSearchPattern)],
      }),
    );
    this.partsManagementSearchTextForm.addControl('appliedPMSearchTextFilter', this.formBuilder.control<boolean | null>(null));
  }
}
